import serviceTypesConstants from '@constants/serviceTypes.constants'

export default [
  {
    value: serviceTypesConstants.PLANNING_ORDER,
    label: 'Planning',
  },
  {
    value: serviceTypesConstants.ALIGNER_ORDER,
    label: 'Aligner Order (Planning and Manufacturing)',
  },
]
